import React from "react";
import { motion } from "framer-motion";

function Quizz({ children, index, side }) {
  const isLeft = side === "left";

  return (
    <motion.div
      className="card"
      style={{
        width: "350px", // Fixed width
        height: "100%", // Full height
        overflow: "hidden", // Prevent content overflow
      }}
      initial={{
        opacity: 0,
        x: isLeft ? -50 : 50, // Slide from left if `side` is "left", else from right
      }}
      whileInView={{
        opacity: 1,
        x: 0, // Slide to its original position
        transition: {
          duration: 1, // Animation duration
        },
      }}
      viewport={{ once: true }}
    >
      {children}
    </motion.div>
  );
}

export default Quizz;
